<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.MembershipMaster.msg1') }}</div>
        <div class="ft-point" style="font-size: 1.5em">
          {{ $t('Modal.MembershipMaster.msg2') }}
        </div>
      </div>
      <div class="layer__body" style="min-height: 21vh">
        <div class="layer__body mg-sm" style="margin-top: 0px">
          <div>
            <img src="@/assets/images/user/artwork_popup_members_3d.gif" alt="" class="img-size" />
          </div>

          <div class="flex-row">
            <div class="input-area">
              <label for="">{{ $t('Modal.MembershipMaster.msg3') }}</label>
              <input
                style="font-size: 1.8em"
                type="text"
                v-if="!eyeActive"
                maxlength="11"
                :placeholder="$t('Modal.MembershipMaster.msg5')"
                :value="reciptData"
                readonly
              />
              <input
                style="font-size: 1.8em"
                type="text"
                v-if="eyeActive"
                maxlength="11"
                :placeholder="$t('Modal.MembershipMaster.msg5')"
                :value="orgReciptData"
                readonly
              />
              <button class="btn-eye" :class="{masking: !eyeActive}" @mouseup="eyeActive = eyeActive ? false : true"></button>
            </div>
            <div class="lyr-right" style="width: 100%; margin: 0px 8em 0em 8.5em">
              <div class="keypad">
                <button @mouseup="setRecipt(1)">1</button>
                <button @mouseup="setRecipt(2)">2</button>
                <button @mouseup="setRecipt(3)">3</button>
                <button @mouseup="setRecipt(4)">4</button>
                <button @mouseup="setRecipt(5)">5</button>
                <button @mouseup="setRecipt(6)">6</button>
                <button @mouseup="setRecipt(7)">7</button>
                <button @mouseup="setRecipt(8)">8</button>
                <button @mouseup="setRecipt(9)">9</button>
                <button @mouseup="setRecipt(10)" class="delete">{{ $t('Modal.MembershipMaster.msg8') }}</button>
                <button @mouseup="setRecipt(0)">0</button>
                <button @mouseup="setRecipt(-1)" class="btn-back">DEL</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="layer__button" v-if="membersType == 'B'">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('membersClose')">{{ $t('Modal.MembershipMaster.msg9') }}</button>
      </div> -->

      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" @mouseup="$emit('membersClose')">
          {{ $t('Modal.MembershipMaster.msg9') }}
        </button>
        <button
          class="btn btn--submit btn-anim"
          @mouseup="membersCheck('')"
          :disabled="orgReciptData.length < 11 || callYn"
          :class="[orgReciptData.length < 11 ? 'btn--disabled' : 'btn--color']"
        >
          {{ $t('Modal.MembershipMaster.msg6') }}
        </button>
      </div>
    </div>

    <div class="dimed wrap" v-if="checkYn">
      <div class="layer layer--sm">
        <div class="layer__body">
          <div class="ft--xlg ft--bold">{{ membersName }} {{ $t('Modal.MembershipMaster.msg10') }}</div>
          <div class="ft--xlg ft--bold">{{ $t('Modal.MembershipMaster.msg11') }}</div>
        </div>
        <div class="layer__button">
          <button
            class="btn btn--cancel"
            @mouseup="
              checkYn = false;
              callYn = false;
            "
          >
            {{ $t('Modal.MembershipMaster.msg9') }}
          </button>
          <button class="btn btn--submit" @mouseup="setMembersObj()">{{ $t('Modal.MembershipMaster.msg7') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'membershipMaster',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      reciptData: '',
      orgReciptData: '', //'01027097622',
      eyeActive: false,
      membersType: 'P',
      checkYn: false,
      membersName: '',
      membersObj: null,
      callYn: false,
      posTransaction: null,
    };
  },
  mounted() {},
  props: {},
  methods: {
    //멤버쉽 객체 담기
    setMembersObj() {
      this.checkYn = false;
      this.$emit('setMembersObj', this.membersObj);
    },
    //멤버쉽 조회 api
    membersCheck(barcode) {
      this.membersObj = {
        point: {
          MessageCodeNo: 0,
          CUST_CARD_NO: '',
          CUST_ID: '2300000168',
          CUST_NM: '스파로스',
          CUST_WEB_ID: '',
          UPOINT: 100000,
          TPOINT: 100000,
          GPOINT: 0,
          PwInUse: true,
          PwUsageCriteriaAmt: 3000,
          MininumUnitOfUse: 1000,
          UnitOfUse: 1000,
          LimitOfUsePoint: 100000000,
          Level: '',
          LevelCode: '',
          IsSaveAvailability: false,
          PhoneFullNo: this.orgReciptData,
        },
        coupon: {
          MessageCodeNo: 0,
          PageNo: 0,
          Size: 0,
          TotalRows: 0,
          CouponList: [
            {
              CouponPublishNo: '6023000006000898',
              CouponName: '커피교환권',
              MberNo: '2300000168',
              PublishDate: '2023-06-07',
              ValidStartDate: '2023-06-07',
              ValidEndDate: '2999-12-31',
              Available: true,
              CouponType: 'EXCHANGE',
              DiscountType: 'FLAT_RATE',
              DiscountValue: 3000,
              MaxDiscountAmount: 0,
              CouponPluList: [
                {
                  GoodsCode: '00006269',
                  GoodsName: 'Espresso',
                },
                {
                  GoodsCode: '00000091',
                  GoodsName: 'Americano',
                },
                {
                  GoodsCode: 'CEP00BCF00012NNFF',
                  GoodsName: 'Long black',
                },
                {
                  GoodsCode: 'CEP00BCF00013NNFF',
                  GoodsName: 'Caffe Latte',
                },
                {
                  GoodsCode: 'CEP00BCF00014NNFF',
                  GoodsName: 'Flat White',
                },
              ],
            },
            {
              CouponPublishNo: '6023000006000891',
              CouponName: '금액 할인권',
              MberNo: '2300000168',
              PublishDate: '2023-06-07',
              ValidStartDate: '2023-06-07',
              ValidEndDate: '2999-12-31',
              Available: true,
              CouponType: 'DISCOUNT',
              DiscountType: 'FLAT_RATE',
              DiscountValue: 30000,
              MaxDiscountAmount: 0,
              CouponPluList: [],
            },
            {
              CouponPublishNo: '6023000006000892',
              CouponName: '% 할인권',
              MberNo: '2300000168',
              PublishDate: '2023-06-07',
              ValidStartDate: '2023-06-07',
              ValidEndDate: '2999-12-31',
              Available: true,
              CouponType: 'DISCOUNT',
              DiscountType: 'FIXED_RATE',
              DiscountValue: 10,
              MaxDiscountAmount: 500,
              CouponPluList: [],
            },
          ],
        },
      };
      this.membersObj.point.PhoneFullNo = barcode == '' ? this.orgReciptData : '';
      this.checkYn = true;
      this.membersName = this.membersObj.point.CUST_NM;

      this.posTransaction = '';
      this.$emit('setPosTransaction', this.posTransaction);
    },
    setRecipt(num) {
      if (num == 10) this.orgReciptData = '';
      else if (num < 0) this.orgReciptData = this.orgReciptData.slice(0, -1);
      else if (this.orgReciptData.length < 11) this.orgReciptData += num + '';

      var str = this.orgReciptData.split('');
      for (let i = 0; i < str.length; i++) {
        if (i >= 3 && i <= 6) {
          str[i] = '*';
        }
      }

      this.reciptData = str.join('');
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  unmounted() {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .ft-point {
    font-size: 1.2em !important;
  }
}
.lyr-txt > div {
  display: inline-block !important;
}

.lyr-txt label {
  width: 29vw !important;
  height: 4.5vh !important;
  margin: 0px 0.4em 1vh !important;
}

.keypad button {
  box-shadow: rgba(0, 0, 0, 0.3) 2px 5px 10px;
}
</style>
